import React from "react";

const reviews = [
  {
    name: "Miloš, Beograd",
    text: "Najbolja sarma koju sam jeo u gradu. Osoblje je izuzetno ljubazno, a atmosfera kao kod bake na selu.",
    rating: 5
  },
  {
    name: "Ana i Marko",
    text: "Ovde smo slavili venčanje – hrana je bila vrhunska, sala prelepa, a organizacija besprekorna.",
    rating: 5
  },
  {
    name: "Ivana, Novi Sad",
    text: "Noćili smo posle proslave – sobe su veoma čiste i udobne, doručak obilan i ukusan.",
    rating: 4
  }
];

export function ReviewsSection() {
  return (
    <section className="section">
      <div className="section-inner">
        <header className="section-header">
          <p className="section-eyebrow">Utisci gostiju</p>
          <h2 className="section-title">Šta gosti kažu o nama</h2>
        </header>
        <div className="reviews-grid">
          {reviews.map((review) => (
            <article key={review.name} className="review-card">
              <div className="review-rating" aria-label={`${review.rating} zvezdica`}>
                {"★".repeat(review.rating)}
                {"☆".repeat(5 - review.rating)}
              </div>
              <p className="review-text">“{review.text}”</p>
              <p className="review-name">{review.name}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

